
webpack.register(
    'components/audio-landing/live-audio-right-rail/live-audio-right-rail-leaderboard/leaderboard-mini/leaderboard-mini',
    function() {
        return require('components/audio-landing/live-audio-right-rail/live-audio-right-rail-leaderboard/leaderboard-mini/leaderboard-mini');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/audio-landing/live-audio-right-rail/live-audio-right-rail-leaderboard/leaderboard-mini/leaderboard-mini'/>\r\n\r\n<div class=\"s-right-rail-leaderboard-audio\">\r\n\r\n    <div class=\"s-right-rail-leaderboard-audio-title\">Leader board</div>\r\n\r\n    <leaderboard-mini (fav-toggled)=\"favToggled\" {(standings)}=\"standings\" {(favorites)}=\"favorites\" {short}=\"short\" {is-live}=\"true\"></leaderboard-mini>\r\n\r\n</div>\r\n");